import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Button, ImageLoader, RadioButtons } from '../_atoms';
import { LoaderSpinner } from './loaderAndSpinners';
import { getCalculatedPrice } from '../redux/actions/products';
import backImg from '../styles/images/icons/back.png';
import Spinner from '../styles/images/spinner.gif';
import '../styles/book_preview.scss';
import { useBlockDimensions } from '../helpers/useBlockDimensions';
import { useScrollTop } from '../helpers/useScrollTop';
import { useQuery } from '../helpers/useQuery';

const useOptionsExtra = id => {
  switch (id) {
    case 'photo-strip-RU':
    case 'photo-book-RU':
    case 'photo-book-RU-slim':
    case 'photo-book-RU-light':
    case 'photo-book-RU-soft':
    case 'notebook-RU':
    case 'calendar-RU-table':
    case 'photo-poster-RU':
      return [{ id: 'squire', label: 'Квадратная' }];
    default:
      return [{ id: 'squire', label: 'Квадратный' }];
  }
};
const getSizeTitle = id => {
  switch (id) {
    case 'gift-cert-RU':
      return 'Номинал';
    case 'futbolki-dlia-dietiei':
      return 'Рост';
    case 'ny_products':
      return 'Выберите подарок';
    case 'kruzhki':
    case 'fotopazly-maghnitnyie':
    case 'fotopazly-kartonnyie':
      return 'Тип';
    case 'photo-mosaic':
    case 'module':
      return 'Формат';
    case 'tarielka-s-fotoghrafiiei':
      return 'Диаметр';
    case 'photo-strip-RU':
      return 'Количество полосок';
    default:
      return 'Размер';
  }
};

const getPepperTypeTitle = id => {
  switch (id) {
    case 'fotoghrafii-v-ramkie':
      return 'Тип Рамки';
    case 'fotomaghnity':
    case 'fotopazly-maghnitnyie':
      return 'Тип Магнита';
    case 'canvas-dream-art':
    case 'photo-mosaic':
    case 'module':
      return 'Материал';
    case 'notebook-RU':
      return 'Бумага';
    case 'futbolki-dlia-vzroslykh':
      return 'Фасон';
    case 'piechat-na-kholstie':
      return 'Способ исполненения';
    default:
      return 'Тип Бумаги';
  }
};

const getOrientationTypeTitle = id => {
  switch (id) {
    case 'photo-strip-RU':
    case 'photo-book-RU':
    case 'photo-book-RU-slim':
    case 'photo-book-RU-light':
    case 'photo-book-RU-soft':
    case 'notebook-RU':
    case 'calendar-RU-magnet':
    case 'calendar-RU-table':
    case 'calendar-RU':
    case 'photo-poster-RU':
      return 'Ориентация';
    default:
      return 'Тип Альбома';
  }
};

const getPriceTitle = (id, sizeId) => {
  if (
    ['photo-book-RU', 'photo-book-RU-slim', 'photo-book-RU-light', 'photo-book-RU-soft'].includes(id) &&
    !['wedding-30x30', 'wedding-20x20', 'wedding-20x30-horizontal'].includes(sizeId)
  ) {
    return 'Цена от';
  }
  return 'Цена';
};

const castle = (options, id, { size, pepperType, albumType }) => {
  switch (id) {
    case 'fotomaghnity':
      return options.filter(
        o => o.includes(size) && (pepperType !== 'acrylic' ? !o.includes('acrylic') : o.includes(pepperType))
      );
    case 'photos':
      return options.filter(o => (size === '10x10' ? o.includes(size) && !o.includes('polaroid') : o.includes(size)));
    case 'gift-cert-RU':
      return options.filter(o => o === `gift-cert-RU-${size}`);
    case 'futbolki-dlia-vzroslykh':
      return options.filter(o => o === `futbolki-dlia-vzroslykh-razmier-${size}`);
    case 'photo-book-RU':
      return options.filter(o => o.includes(size) && o.includes(albumType === 'squire' ? '' : albumType));
    case 'photo-book-RU-slim':
      return options.filter(
        o =>
          (size === '10x15' ? o.includes(size) && !o.includes('half') : o.includes(size)) &&
          o.includes(albumType === 'squire' ? '' : albumType)
      );
    case 'photo-book-RU-light':
      return options.filter(
        o =>
          (size === '10x15' ? o.includes(size) && !o.includes('half') : o.includes(size)) &&
          o.includes(albumType === 'squire' ? '' : albumType)
      );
    case 'tarielka-s-fotoghrafiiei':
      return options.filter(o => o.includes(size));
    default:
      return options;
  }
};

const BookPreview = ({ item, buttonText, onSelectProduct, onBack, extraItems, priceModifier }) => {
  const { page } = useParams();
  const query = useQuery();
  useScrollTop();
  const { orientation, type, size: sizeInitial } = query;
  const { blockRef, isScrollable } = useBlockDimensions();

  const sizesOptions = item.sizes;
  const peppersOptions = item.types;
  const albumOptions = item.orientation;

  const [fullDescription, setFullDescription] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [idError, setIdError] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [size, setSize] = useState('');
  const [pepperType, setPepperType] = useState(peppersOptions.find(({ id }) => id === type)?.id || '');
  const [albumType, setAlbumType] = useState(albumOptions.find(({ id }) => id === orientation)?.id || '');
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [{ min, max }, setMinMax] = useState({ min: null, max: null });
  const [selectedId, setSelectedId] = useState('');
  const albumOptionsExtra = useOptionsExtra(item.id);

  useEffect(() => {
    setSize(sizesOptions.find(({ id }) => id === sizeInitial)?.id || '');
  }, [sizeInitial, sizesOptions]);

  const onPrevClick = () => setCurrentImage(v => (v < 0 ? item.additional_photo.length - 1 : v - 1));
  const onNextClick = () => setCurrentImage(v => (v >= item.additional_photo.length ? 0 : v + 1));

  const onChangeSize = el => {
    setSize(el.id);
    const currentSizes = el.label.replace(/[^x\d]/gi, '').split('x');
    if (currentSizes[0] === currentSizes[1]) {
      setAlbumType(albumOptionsExtra[0].id);
    } else if (albumOptionsExtra[0].id === albumType) {
      setAlbumType(albumOptions[0]?.id || '');
    }
  };

  const onContinue = () => {
    if (loading) return;
    let errorMessage = '';
    const errors = [];
    if (sizesOptions.length && !size) errors.push('размер');
    if (peppersOptions.length && !pepperType) errors.push('тип бумаги');
    if (albumOptions.length && !albumType) errors.push('тип альбома');
    if (errors.length) errorMessage = `Пожалуйста выберите: ${errors.join(', ')}`;
    setValidationError(errorMessage);
    if (errorMessage) return;
    onSelectProduct({
      productType: page,
      productTypeId: item.id,
      type: pepperType,
      orientation: albumType,
      size,
      price,
      max,
      min,
      id: selectedId,
      shilda: '',
      leatherCover: false,
    });
  };

  const getPrice = () => {
    if (sizesOptions.length && !size) return;
    if (peppersOptions.length && !pepperType) return;
    if (albumOptions.length && !albumType) return;
    let { options } = item;
    options = castle(options, item.id, { size, pepperType, albumType });
    if (options.length === item.options.length && options.length !== 1) {
      if (sizesOptions.length)
        options = options.filter(id => id.slice(id.includes(item.id) ? item.id.length : 0).includes(size));
      if (peppersOptions.length)
        options = options.filter(id => id.slice(id.includes(item.id) ? item.id.length : 0).includes(pepperType));
      if (albumOptions.length) {
        if (albumType === albumOptionsExtra[0].id)
          options = options.filter(id => !id.includes('vertical') && !id.includes('horizontal'));
        else options = options.filter(id => id.slice(id.includes(item.id) ? item.id.length : 0).includes(albumType));
      }
    }
    setIdError(options.length !== 1);
    setSelectedId(options[0]);
    setLoading(true);
    getCalculatedPrice(options[0])
      .then(d => {
        setPrice(priceModifier ? priceModifier(d.price) : d.price);
        setMinMax({ min: d.min_photos, max: d.max_photos });
        setLoading(false);
      })
      .catch(() => {
        setPrice(0);
        setMinMax({ min: null, max: null });
        setLoading(false);
      });
  };

  const sizeTitle = getSizeTitle(item.id);
  const pepperTypeTitle = getPepperTypeTitle(item.id);
  const orientationTypeTitle = getOrientationTypeTitle(item.id);

  const title = React.useMemo(() => {
    const titles = [];
    if (sizesOptions.length) titles.push(sizeTitle);
    if (peppersOptions.length) titles.push(pepperTypeTitle);
    if (albumOptions.length) titles.push(orientationTypeTitle);

    if (titles.length === 2) {
      return `Выберите ${titles.join(' и ')}`;
    }
    if (titles.length === 3) {
      return `Выберите ${titles.slice(0, -1).join(', ')} и ${titles[titles.length - 1]}`;
    }
    return 'Выберите необходимые параметры ниже';
  }, [sizesOptions, peppersOptions, albumOptions, sizeTitle, pepperTypeTitle, orientationTypeTitle]);

  useEffect(getPrice, [size, albumType, pepperType, priceModifier]);

  return (
    <div className={`book-preview ${item.id}`}>
      {item.id !== 'gift-cert-RU' && <img className="go-back" src={backImg} alt="" role="none" onClick={onBack} />}
      <div className="book-preview__info">
        <div>
          <h2 className="title">{item.name}</h2>
          <div className="image">
            <ImageLoader src={item.additional_photo?.[currentImage] || item.logo} className="books-item-image__image" />
            <div className="chevron left" role="none" onClick={onPrevClick} />
            <div className="chevron right" role="none" onClick={onNextClick} />
          </div>
        </div>
        <p className={`description ${fullDescription ? 'show' : ''}`}>
          <span ref={blockRef} className="description__content">
            {item.description}
            {isScrollable && <div className="shadow" />}
          </span>
          {isScrollable && (
            <Button className="description__show-all" onClick={() => setFullDescription(o => !o)}>
              {fullDescription ? 'Скрыть описание' : 'Показать описание'}
            </Button>
          )}
        </p>
      </div>
      <div className="book-preview__settings">
        <h3 className="book-preview__settings__title">{title}</h3>
        <div className="book-preview__options">
          {!!sizesOptions.length && (
            <>
              <p className="label">{sizeTitle}</p>
              <div className="sizes">
                {sizesOptions.map(el => (
                  <Button key={el.id} className={size === el.id ? 'blue' : ''} onClick={() => onChangeSize(el)}>
                    {el.label}
                  </Button>
                ))}
              </div>
            </>
          )}
          {!!peppersOptions.length && (
            <>
              <p className="label">{pepperTypeTitle}</p>
              <RadioButtons
                name="productType"
                className="types"
                options={peppersOptions}
                onChange={setPepperType}
                checked={pepperType}
              />
            </>
          )}
          {!!albumOptions.length && (
            <>
              <p className="label">{orientationTypeTitle}</p>
              <RadioButtons
                name="pepperType"
                className="album-types"
                options={albumType === albumOptionsExtra[0].id ? albumOptionsExtra : albumOptions}
                onChange={setAlbumType}
                checked={albumType}
              />
            </>
          )}
          {extraItems}
        </div>
        <div className="book-preview__extra">
          <div className="price">
            {idError ? (
              'Товар снят с продажи. Попробуйте другие варианты'
            ) : loading ? (
              <img src={Spinner} alt="" className="gifSpinner" />
            ) : (
              `${getPriceTitle(item.id, size)}: ${price}р.`
            )}
          </div>
          <Button className="blue" disabled={idError} onClick={onContinue}>
            {buttonText ?? 'Начать оформление'}
          </Button>
        </div>
      </div>
      <LoaderSpinner
        showLoader={validationError}
        showAnswer={validationError}
        closeLoader={() => setValidationError('')}
      />
    </div>
  );
};

export default BookPreview;
